export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			trackActiveIndex: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "anchorNav";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.$links = this.$el.querySelectorAll("a");
			this.$targets = [];
			window.addEventListener("load", () => {
				this.$links.forEach(($link) => {
					const $target = document.querySelector(
						$link.getAttribute("href")
					);
					this.$targets.push($target);
				});
				this.$targets.forEach(($target, i) => {
					const $link = this.$links[i];

					$link.addEventListener("click", (e) => {
						e.preventDefault();
						$target.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
					});
				});
			});
			window.addEventListener("scroll", () => {
				const scrollPos = window.scrollY;
				if (this.$targets.length > 0) {
					// can we do a forEach backwards?
					let activeIndex = null;

					this.$targets.forEach(($target, i) => {
						const $link = this.$links[i];
						let offset = $target.offsetTop - window.innerHeight / 4;
						if ($target.closest("section") && offset < 100) {
							offset =
								$target.closest("section").offsetTop -
								window.innerHeight / 4;
						}

						const height = $target.offsetHeight;
						if (scrollPos >= offset) {
							activeIndex = i;
						}
					});

					if (activeIndex !== this.trackActiveIndex) {
						this.trackActiveIndex = activeIndex;
						this.$links.forEach(($link, i) => {
							if (
								$link.classList.contains("active") &&
								i !== activeIndex
							) {
								$link.classList.remove("active");
							}
						});
						if (activeIndex !== null) {
							this.$links[activeIndex].classList.add("active");
						}
					}
				}
			});
		} else {
		}
	}
}
